module.exports = __webpack_public_path__ + "media/images/mypage/challengers/projects/open_requests/under_examination-182a88f024f6b4d63535985b26dab0ee.svg";